<template>
  <AppLazySelect
    eager
    multiple
    append-to-body
    resource="member"
    label="Teams / members"
    :value="value"
    :fetcher="fetcher"
    @input="$emit('input', $event)"
    @select-all="$emit('select-all')"
  >
    <template #placeholder>Choose who this policy applies to</template>
    <template #item-leading="{ item }">
      <AppAvatar
        :avatar="item.avatar"
        size="speck"
        class="mr-10"
      />
    </template>
  </AppLazySelect>
</template>

<script>
import { AutoTrackRulesResource } from '~/resources';

export default {
  name: 'AutoTrackRulesMemberSelect',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    organizationId: {
      type: Number,
      required: true,
    },
    // When editing a policy, its own members stay eligible (not filtered out as "already in a policy").
    autoTrackRuleId: {
      type: Number,
      default: null,
    },
  },
  // Vue 3 binds undeclared event listeners as native fallthrough on the root AppLazySelect (which
  // also emits `input`), double-firing the selection handler. Inert under Vue 2.
  emits: ['input', 'select-all'],
  methods: {
    // Implements the `AppLazySelect` fetcher contract: server-side paginated, searchable members.
    fetcher(payload) {
      return AutoTrackRulesResource.members(
        { organizationId: this.organizationId },
        { ...payload, auto_track_rule_id: this.autoTrackRuleId },
        { abortReload: true },
      );
    },
  },
};
</script>
